export default "<tc-simple-filter\r\n  #tcSimpleFilter\r\n  (search)=\"onSearch($event)\"\r\n></tc-simple-filter>\r\n";